import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../../../util/reactIntl';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { string } from 'prop-types';
import { propTypes } from '../../../../util/types';
import { StaticPage, TopbarContainer } from '../../../index';
import {
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
    Breadcrumb,
    AccordionItems,
    generateAccordionTableOfContents,
    HorseDealAppTeaser,
    HorseDealCreateAccountTeaser,
} from '../../../../components';

import css from '../LandingPage.css';
import { redirectToURLWithModalState } from '../../../../components/Topbar/Topbar.helpers';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import config from '../../../../config';
import { ReviewsWidget } from '../../../AuthenticationPage/ReviewsWidget';
import { accordionItems1, accordionItems2 } from '../accordionItemsFindCareParticipation';
import { formatNumber } from '../helpers';
import { loadData } from '../../SeoLandingPages.duck';
import { jsonLd } from './json-ld';
import { IconSearchM } from '../../../../icons';
import { getCenterFromBounds } from '../../../../util/location';

const PflegebeteiligungFindenPageComponent = ({ intl, location, history, currentUser }) => {
    const [isMobile] = useIsMobile(1024);

    const metadata = useSelector(s => s.SeoLandingPages?.metadata);

    const { listingTypeHorse } = config;
    const pub_activities = 'Pflegen,Bodenarbeit';
    const boundaries = '58.02241898,19.88235533,42.28105558,-1.21139467';
    const loc = getCenterFromBounds(boundaries);
    const title =
        intl.formatMessage({ id: 'SeoLandingPages.careShare.metaTitle' }) ||
        '▷ Pflegebeteiligung finden - Tipps und Tricks für Pfleger:innen';

    const breadcrumbPaths = [{ label: 'Pflegebeteiligung finden' }];

    const { DE: countHorsesDE, CH: countHorsesCH } = metadata || {};

    return (
        <StaticPage
            title={title}
            schema={{
                '@context': jsonLd['@context'],
                '@type': jsonLd['@type'],
                mainEntity: jsonLd['mainEntity'],
                description: intl.formatMessage({
                    id: 'SeoLandingPages.careShare.metaDescription',
                }),
                name: title,
            }}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>

                <LayoutWrapperMain
                    className={css.staticPageWrapper}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <Breadcrumb paths={breadcrumbPaths} urlPrefix={'/landing'} />

                    <h1 className={css.pageTitle}>
                        <FormattedMessage
                            id="SeoLandingPages.careShare.Title"
                            defaultMessage="{chunk} - Tipps {break}und Ticks für Pfleger:innen"
                            values={{
                                break: <br className={css.pageTitleBreak} />,
                                chunk: (
                                    <span className={css.pageTitleColor}>
                                        {intl.formatMessage({
                                            id: 'SeoLandingPages.careShare.Title-chunk',
                                        })}
                                    </span>
                                ),
                            }}
                        />
                    </h1>

                    <div className={css.coverWrapper}>
                        <div className={css.findPlacesNearby}>
                            <h2 className={css.coverTitle}>
                                Pflegebeteiligungen finden in der Nähe
                            </h2>
                            <p className={css.coverSubTitle}>
                                Finde Pferde auf der Suche nach einer Pflegebeteiligung.
                            </p>
                            <div className={css.dumbInputRoot}>
                                <input
                                    type="text"
                                    className={css.dumbInput}
                                    placeholder="Suche in deiner Nähe"
                                    onFocus={() =>
                                        redirectToURLWithModalState(
                                            { location, history },
                                            isMobile ? 'mobilesearch' : 'desktopsearch'
                                        )
                                    }
                                />
                                <div className={css.dumbFieldIconHolder}>
                                    <IconSearchM />
                                </div>
                            </div>
                            <div className={css.reviewsIframe}>
                                <iframe
                                    name="text-banner-widget_frame"
                                    id="text-banner-widget_frame"
                                    frameBorder="0"
                                    width="100%"
                                    scrolling="no"
                                    height="66"
                                    title="Reviews Widget"
                                    src="https://widget.reviews.io/rich-snippet-reviews-widgets/widget?version=13b&amp;store=www.horsedeal.com&amp;starsClr=%23faba05&amp;textClr=%231a2b49&amp;logoClr=white&amp;widgetName=text-banner&amp;translateOurCustomersSay=%20&amp;translateOutOf5BasedOn=bei&amp;translateReviews=Bewertungen&amp;translateExcellent=Hervorragend&amp;css=.TextBanner%20.ReviewsLogo%20%7B%20display%3A%20none%20%7D&amp;elementId=text-banner-widget&amp"
                                ></iframe>
                            </div>
                        </div>

                        <div
                            id="text-banner-widget"
                            style={{ maxWidth: 0, maxHeight: 0, transform: 'scale(0)' }}
                        />
                        <div
                            id="text-banner-widget-mobile"
                            style={{ maxWidth: 0, maxHeight: 0, transform: 'scale(0)' }}
                        />
                        <div className={css.coverImageWrapper}>
                            <img
                                className={css.coverImage}
                                src="https://horsedeal.imgix.net/static/landingPage/banner/pflegebeteiligung-finden.webp"
                                alt="Pflegebeteiligungen finden"
                            />
                        </div>
                    </div>

                    <div className={css.faq}>
                        <h2 className={css.contentHeading}>Inhaltsverzeichnis</h2>
                        {generateAccordionTableOfContents([accordionItems1, accordionItems2])}
                    </div>

                    <AccordionItems items={accordionItems1} expandFirstElement={true} />

                    <HorseDealCreateAccountTeaser
                        title={intl.formatMessage({
                            id: 'SeoLandingPages.careShare.AccountTeaserTitle',
                        })}
                        participationName={intl.formatMessage({
                            id: 'SeoLandingPages.careShare.AccountTeaserParticipationName',
                        })}
                        currentUser={currentUser}
                        bounds={boundaries}
                        origin={loc}
                        listingType={listingTypeHorse}
                        pub_activities={pub_activities}
                    />

                    <ReviewsWidget className={css.reviewsioCarouselWidget} name={title} />

                    <AccordionItems items={accordionItems2} />

                    <div className={css.ridingSharesEuropeWrapper}>
                        <h2 className={css.ridingSharesEuropeTitle}>
                            Pflegebeteiligungen in{' '}
                            <span className={css.pageTitleColor}>Europa</span>
                        </h2>
                        <p>Finde Pflegebeteiligungen in allen Ländern Europas.</p>
                        <div className={css.ridingSharesEuropeInnerWrapper}>
                            <div className={css.ridingSharesCountry}>
                                <a
                                    href="/landing/pflegebeteiligung-finden/deutschland"
                                    className={css.ridingSharesTitle}
                                >
                                    Pflegebeteiligungen in Deutschland
                                </a>
                                <div className={css.ridingSharesCount}>
                                    {formatNumber(countHorsesDE)}{' '}
                                    {countHorsesDE === 1 ? 'Pferd' : 'Pferde'}
                                </div>
                            </div>
                            <div className={css.ridingSharesCountry}>
                                <a
                                    href="/landing/pflegebeteiligung-finden/schweiz"
                                    className={css.ridingSharesTitle}
                                >
                                    Pflegebeteiligungen in der Schweiz
                                </a>
                                <div className={css.ridingSharesCount}>
                                    {formatNumber(countHorsesCH)}{' '}
                                    {countHorsesCH === 1 ? 'Pferd' : 'Pferde'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <HorseDealAppTeaser />
                </LayoutWrapperMain>

                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </StaticPage>
    );
};

PflegebeteiligungFindenPageComponent.propTypes = {
    title: string,
    currentUser: propTypes.currentUser,
    intl: intlShape.isRequired,
};

const mapStateToProps = state => ({
    currentUser: state.user.currentUser,
});

const PflegebeteiligungFindenPage = compose(
    connect(mapStateToProps),
    withRouter,
    injectIntl
)(PflegebeteiligungFindenPageComponent);

PflegebeteiligungFindenPage.loadData = loadData;

export default PflegebeteiligungFindenPage;
